<div class="novo-orcamento-page">
  <div class="page-header">
    <h4>Novo Orçamento</h4>
    <button type="button" class="btn btn-outline-secondary" (click)="voltar()">
      <i class="fa fa-arrow-left"></i> Voltar
    </button>
  </div>

  <div class="card-box mb-3">
    <div class="row g-3">
      <div class="col-md-8">
        <label class="form-label">Título *</label>
        <input class="form-control" [(ngModel)]="titulo" />
      </div>
      <div class="col-md-4">
        <label class="form-label">Tribunal</label>
        <input class="form-control" [(ngModel)]="tribunal" />
      </div>
      <div class="col-md-12">
        <div class="text-end">
          <button type="button" class="btn btn-primary" (click)="realizarOrcamento()" [disabled]="calculando">
            <i class="fa fa-calculator"></i> {{ calculando ? 'Calculando...' : 'Realizar Orçamento' }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="card-box">
    <div class="table-responsive tree-table-wrapper">
      <table class="table table-sm align-middle mb-0 tree-table">
        <thead>
          <tr>
            <th class="col-action"></th>
            <th class="col-action"></th>
            <th class="col-tag">Tag</th>
            <th class="col-nome">Nome</th>
            <th class="col-cc">CC</th>
            <th class="col-num">Nasc</th>
            <th class="col-cc">CC</th>
            <th class="col-num">Cas</th>
            <th class="col-num">Out</th>
            <th class="col-num">NN</th>
            <th class="col-num">Proc</th>
            <th class="col-num">Req</th>
            <th class="col-num">Men</th>
            <th class="col-obs">Observação</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let node of tree; let i = index">
            <td class="text-center">
              <button type="button" class="btn btn-sm btn-success" (click)="addNewLine(node, i)" title="Adicionar filho">
                <i class="fa fa-plus"></i>
              </button>
            </td>
            <td class="text-center">
              <button type="button" class="btn btn-sm btn-danger" (click)="removeNo(node)" title="Remover nó">
                <i class="fa fa-trash"></i>
              </button>
            </td>
            <td><input class="form-control form-control-sm input-tag" [(ngModel)]="node.tag" /></td>
            <td><input class="form-control form-control-sm input-nome" [(ngModel)]="node.name" /></td>
            <td>
              <select class="form-control form-control-sm input-cc" [(ngModel)]="node.ehCCCasamento">
                <option value="N">N</option>
                <option value="S">S</option>
              </select>
            </td>
            <td><input class="form-control form-control-sm input-num" type="number" min="0" [(ngModel)]="node.qtdNascimento" /></td>
            <td>
              <select class="form-control form-control-sm input-cc" [(ngModel)]="node.ehCCNascimento">
                <option value="N">N</option>
                <option value="S">S</option>
              </select>
            </td>
            <td><input class="form-control form-control-sm input-num" type="number" min="0" [(ngModel)]="node.qtdCasamento" /></td>
            <td><input class="form-control form-control-sm input-num" type="number" min="0" [(ngModel)]="node.qtdOutro" /></td>
            <td><input class="form-control form-control-sm input-num" type="number" min="0" [(ngModel)]="node.qtdNN" /></td>
            <td><input class="form-control form-control-sm input-num" type="number" min="0" [(ngModel)]="node.qtdProcuracao" /></td>
            <td><input class="form-control form-control-sm input-num" type="number" min="0" [(ngModel)]="node.qtdRequerente" /></td>
            <td><input class="form-control form-control-sm input-num" type="number" min="0" [(ngModel)]="node.qtdMenor" /></td>
            <td>
              <input class="form-control form-control-sm input-obs" [(ngModel)]="node.obs" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="card-box mt-3" *ngIf="resultadoParcelas.length > 0">
    <div class="table-responsive">
      <table class="table table-sm align-middle mb-0">
        <thead>
          <tr>
            <th>Etapa</th>
            <th>Parcela Total Grupo</th>
            <th>Parcela de Cada Menor</th>
            <th>Parcela de Cada Maior</th>
            <th>Forma de Pagamento</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of resultadoParcelas">
            <td>{{ item.etapa || '-' }}</td>
            <td>R$ {{ formatarNumero(item.totaGrupo || 0) }}</td>
            <td>R$ {{ formatarNumero(item.parcelaCadaMenor || 0) }}</td>
            <td>R$ {{ formatarNumero(item.parcelaCadaMaior || 0) }}</td>
            <td>{{ item.formaPagamento || '-' }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="totais mt-3">
      <div><strong>Total grupo:</strong> R$ {{ formatarNumero(totalOrcamento.totalGrupo) }}</div>
      <div><strong>Total cada menor:</strong> R$ {{ formatarNumero(totalOrcamento.totalCadaMenor) }}</div>
      <div><strong>Total cada maior:</strong> R$ {{ formatarNumero(totalOrcamento.totalCadaMaior) }}</div>
    </div>
  </div>

  <div class="card-box mt-3">
    <label class="form-label">Observação Geral</label>
    <textarea class="form-control" rows="3" [(ngModel)]="observacao"></textarea>

    <div class="acoes mt-3">
      <button type="button" class="btn btn-info me-2" (click)="limparTableResultado()">
        <i class="fa fa-eraser"></i> Limpar Orçamento
      </button>
      <button type="button" class="btn btn-outline-secondary me-2" (click)="voltar()">Voltar</button>
      <button type="button" class="btn btn-success" [disabled]="salvando" (click)="salvar()">
        <i class="fa fa-save"></i> {{ salvando ? 'Salvando...' : 'Salvar' }}
      </button>
    </div>
  </div>
</div>
